import React from 'react';
import { Spin, Icon } from 'antd';
import './style.css';

const Spinner = (props) => {
    const antIcon = <Icon type="loading" style={{ fontSize: 48 }} spin />;
    
    return (
        <div className="spinner-container">
            <Spin indicator={antIcon} />
        </div>
    );
};

export default Spinner;


// WEBPACK FOOTER //
// ./src/components/Spinner/index.js